import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Icon from 'components/common/Icon/Icon'
import Theme from 'components/common/Theme/Theme'

const Notification = ({
  title = '',
  className = '',
  asset = '',
  width = 25,
  height = 25,
  success = false
}) =>
  <Wrapper className={ className } success={ success }>
    <StatusIcon asset={ asset } width={ width } height={ height } />
    { title }
  </Wrapper>

export default Notification

Notification.propTypes = {
  asset: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.number,
  success: PropTypes.bool,
  title: PropTypes.string,
  width: PropTypes.number
}

const Wrapper = styled.div`
  position: fixed;
  padding: 18px 34px;
  top: 50%;
  left: 50%;
  display: none;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  transform: translateX(-50%) !important;
  z-index: 99999;

  &.show {
    display: flex;
  }

  ${Mixin.font.GothamBold(14)};
  ${props => props.success && css`
    border: 1px solid ${Theme.colors.green};
    color: ${Theme.colors.green};
    background: #ecf6f1;
  `}
  ${Media.mobile`
    width: 310px;
  `}
`

const StatusIcon = styled(Icon)`
  margin-right: 10px;
`
